<template>
  <BreadCrumb />
  <ParagraphCustom title="Shrub or Tree?">
    <p>
      Generally speaking, if it has a distinct woody trunk, it is a tree. The
      distinction, however, is not always simple; some plants can be shrubs and
      trees. Kawakawa and Manuka, for example, can be either. Two common native
      trees (Kaikomako and Putaputaweta) are particularly tricky in that they
      have very different shrub-like form when young.
    </p>
  </ParagraphCustom>
  <div class="plant-image-base">
    <div>
      <img
        src="@/assets/shrubs/kawakawa.jpg"
        class="plant-image"
        img-alt="image plant"
      />
      <p class="text-center">Kawakawa leaves</p>
    </div>
    <div>
      <img
        src="@/assets/shrubs/leptospermum.jpg"
        class="plant-image"
        img-alt="image plant"
      />
      <p class="text-center">Leptospermum commonly called Manuka</p>
    </div>
  </div>
  <ParagraphCustom color="secondary">
    <div class="plant-text">Sources:</div>
  </ParagraphCustom>
</template>
<script>
import ParagraphCustom from "../ParagraphCustom.vue";
import BreadCrumb from "../BreadCrumb/BreadCrumb.vue";
export default {
  name: "IdentifyPage",
  components: { ParagraphCustom, BreadCrumb },
};
</script>
<style lang="scss" scoped>
.plant-image-base {
  flex-direction: column;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: $spacing-small;
  @media (min-width: $constraint-width-medium) {
    flex-direction: row;
  }
}
.plant-image {
  margin-right: $spacing-small;
  max-width: 300px;
}
.text-center {
  text-align: center;
}
</style>
